import SupportPanel from './Support/SupportPanel';

export default function Soporte() {
  return (
    <div className="tab-content">
      <SupportPanel />
    </div>
  );
}

